import Vue from "vue";
import i18n from "vue-i18n"
export default {
  state: {
    menu: {
      sistema_operativo: "Sistema Operativo",
      navegador: "Navegador",
      logo: "",
      salir: false,
      filtros: {
        fechas: {
          fecha_inicial: "20-01-2020",
          fecha_final: "20-01-2020",
          mostrar: false
        }
      },
      datos: {
        catalogos: {
          recursos_capacitacion: {
            instituciones: [],
            instructores: [],
            salas: [],
            sedes: []
          }
        },
        plan_capacitacion: {
          capacitacion_institucional: {
            consulta_requerimientos: {
              por_estructuras: [],
              por_puestos: []
            }
          },
          plan_formacion: {
            baja_requerimientos: {
              por_puestos: [],
              por_estructuras: []
            }
          },
          capacitacion_especifica: {
            consulta_requerimientos: {
              por_estructuras: [],
              por_empleados: [],
              por_programa: []
            }
          },
          consultar_plan_capacitacion: {
            calificada: [],
            planeada: []
          }
        },
        cursos: {
          participantes: {
            dc3: {
              empleado: {
                cve_empleado: null,
                nombre_empleado: ""
              },
              curso: {
                cve_curso: null,
                tema_institucional: ""
              }
            }
          }
        }
      },
      buttons: {
        excel: false,
        consultar: false,
        action_button:false,
        action_button_text:'action_select',
        consultar_name: "Actualizar",
        nuevo: false,
        nuevo_name: "Nuevo",
        crear_puesto: false,
        imprimir: false,
        help: {
          mostrar: false,
          title: "",
          content: ""
        }
      },
      excel: {
        fileName: "",
        data: "",
        headers: "",
        query: {},
        buscando: false
      },
      excel_modal: {
        fileName: "",
        data: "",
        headers: ""
      },
      opcion: {
        name: "",
        mostrar_name: true,
        origin1: {
          name: "",
          route: "Dashboard"
        },
        origin2: {
          name: "",
          route: ""
        },
        origin3: {
          name: "",
          route: ""
        }
      },
      token: "",
      tokenGenerico: "",
      usuario: {},
      usuario_permisos: {
        nomseccion1: [],
        nomseccion2: [],
        nomseccion3: [],
        nomseccion4: []
      }
    }
  },
  mutations: {
    setUsuario_Permisos(state, data) {
      state.menu.usuario_permisos = data;
    },
    setHelpButton(state, data) {
      state.menu.buttons.help = data;
    },
    setUsuario(state, usuario) {
      state.menu.usuario = usuario;
    },
    setOpcion(state, opcion) {
      state.menu.opcion.name = opcion;
    },
    setToken(state, token) {
      state.menu.token = token;
      localStorage.removeItem("apiKey_lms");
      localStorage.apiKey_lms = JSON.stringify(token);
    },
    setTokenGenerico(state, token) {
      state.menu.tokenGenerico = token;
    }
  },
  actions: {
    Definir_Permisos_Del_Usuario(context) {
      var idperfil = context.state.menu.usuario.idperfil;
      var perfiles_secciones =
        context.rootState.perfiles.perfiles.perfiles_secciones;
      var usuario_permisos = {
        nomseccion1: [],
        nomseccion2: [],
        nomseccion3: [],
        nomseccion4: []
      };

      for (var i = 0; i < perfiles_secciones.length; i++) {
        if (perfiles_secciones[i].idperfil == idperfil) {
          usuario_permisos.nomseccion1.push(perfiles_secciones[i].nomseccion1);
          usuario_permisos.nomseccion2.push(perfiles_secciones[i].nomseccion2);
          usuario_permisos.nomseccion3.push(perfiles_secciones[i].nomseccion3);
          usuario_permisos.nomseccion4.push(perfiles_secciones[i].nomseccion4);
        }
      }

      context.commit("setUsuario_Permisos", usuario_permisos);
    },
    Abrir_Ventana_Confirmacion() {
      $("#button_modal_ventana_confirmacion").click();
    },
    Actualizar_TokenFCM({ commit, state }, tokenfcm) {
      /*
      firebase.firestore().collection('sesiones').add({
        idempleado: state.menu.usuario.cve_empleado,
        nombre_empleado:state.menu.usuario.nombre_empleado,
        tipo: 1,
        tokenfcm: tokenfcm,
        fecha_hora:firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(refDoc => {

      })
      .catch(error => {

      });
      */
    },
    Formato_Fecha_Dia_Semana({ commit, state }, fecha_a_convertir) {
      var meses = new Array(
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      );
      var diasSemana = new Array(
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado"
      );
      var f = new Date(fecha_a_convertir);
      var fecha_convertida =
        diasSemana[f.getDay()] +
        ", " +
        f.getDate() +
        " de " +
        meses[f.getMonth()] +
        " de " +
        f.getFullYear();
      return fecha_convertida;
    },
    Actualizar_Help_Button({ commit, state }, data) {
      commit("setHelpButton", data);
    },
    Actualizar_Usuario(context, data) {
      context.commit("setUsuario", data.usuario);
      context.commit("setToken", data.token);
      context.dispatch("Definir_Permisos_Del_Usuario");
    },
    Definir_Opciones_Menu_Lateral({ commit, state }, usuario) { },
    Actualizar_Token({ commit, state }, token) {
      commit("setToken", token);
    },
    Actualizar_TokenGenerico(context, token) {
      context.commit("setTokenGenerico", token);
      context.dispatch("Consultar_Secciones");
    },
    async Json_to_Excel({ commit, state }) {
      state.menu.excel.buscando = true;
      var headers = [];
      var items = [];
      var fileName = state.menu.excel.fileName;
      if (state.menu.excel.query != {}) {
        await Vue.http
          .post(state.menu.excel.query.url, {
            excel: true,
            fecha_inicial: state.menu.excel.query.fecha_inicial,
            fecha_final: state.menu.excel.query.fecha_final,
            columns_with_selects: state.menu.excel.query.columns_with_selects,
            order: state.menu.excel.query.order,
            ordertype: state.menu.excel.query.ordertype,
            cantPP: state.menu.excel.query.cantPP
          })
          .then(respuesta => {
            return respuesta.json();
          })
          .then(respuestaJson => {
            items = items.concat(respuestaJson.result);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(response => {
            console.log("acabó");
          });

        let newItems = [];
        for (let i = 0; i < items.length; i++) {
          let newItem = {};
          for (
            let j = 0;
            j < state.menu.excel.query.columns_with_selects.length;
            j++
          ) {
            if (
              state.menu.excel.query.columns_with_selects[j].column != "" &&
              (state.menu.excel.query.columns_with_selects[j].input != "button" || state.menu.excel.query.columns_with_selects[j].nomfield == 'costo_total')
            ) {
              let nomfield;
              if (
                state.menu.excel.query.columns_with_selects[j].nomfield.split(
                  "."
                ).length > 1
              ) {
                nomfield = state.menu.excel.query.columns_with_selects[
                  j
                ].nomfield.split(".")[1];
              } else {
                nomfield =
                  state.menu.excel.query.columns_with_selects[j].nomfield;
              }
              console.log(nomfield)
              newItem[nomfield] = items[i][nomfield];
            }
          }
          newItems.push(newItem);
        }
        for (
          let j = 0;
          j < state.menu.excel.query.columns_with_selects.length;
          j++
        ) {
          if (
            state.menu.excel.query.columns_with_selects[j].column != "" &&
            (state.menu.excel.query.columns_with_selects[j].input != "button" || state.menu.excel.query.columns_with_selects[j].nomfield == 'costo_total')
          ) {
            headers.push(Vue.i18n.t(state.menu.excel.query.columns_with_selects[j].column));
          }
        }
        items = newItems;
        items.unshift(headers);
      } else {
        headers = state.menu.excel.headers;
        items = state.menu.excel.data;
        if (headers) {
          items.unshift(headers);
        }
      }

      const jsonObject = JSON.stringify(items);

      const array =
        typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;

      let str = "";

      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (let index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }

        str += line + "\r\n";
      }

      const csv = str;

      const exportName = fileName + ".csv" || "exportable.csv";

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      state.menu.excel.buscando = false;
    },
    Json_to_Excel_Modal({ commit, state }) {
      var headers = state.menu.excel_modal.headers;
      var items = state.menu.excel_modal.data;
      var fileName = state.menu.excel_modal.fileName;
      if (headers) {
        items.unshift(headers);
      }

      const jsonObject = JSON.stringify(items);

      const array =
        typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;

      let str = "";

      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (let index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }

        str += line + "\r\n";
      }

      const csv = str;

      const exportName = fileName + ".csv" || "export.csv";

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    data_to_excel({ }, payload) {
      const jsonObject = JSON.stringify(payload.elements);
      const array =
        typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;

      let str = Object.keys(array[0]).join(",") + "\r\n";
      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (let index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }

        str += line + "\r\n";
      }
      const csv = str;

      const exportName = payload.text + ".csv" || "exportable.csv";

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    data_replace_keys({ }, payload) {
      let arrTemp = [];
      payload.elements.forEach(element => {
        let temp = {};
        Object.keys(element).map(key => {
          const newKey = payload.replacements[key] || key;
          temp[newKey] = element[key];
        });
        arrTemp.push(temp);
      });
      return arrTemp;
    }
  },
  getters: {
    getMenu(state) {
      return state.menu;
    },
    getHelp(state) {
      return state.menu.buttons.help;
    },
    getUsuario(state) {
      return state.menu.usuario;
    },
    getUsuario_Permisos(state) {
      return state.menu.usuario_permisos;
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/menu.js